import { useMutation } from '@apollo/client'
import * as React from 'react'
import { IconButton, Icon } from '@material-ui/core'
import { ActionSheet } from 'components'
import Avatar from '../../Avatar'
import { format } from 'utils/date'
import { Description } from 'components'
import truncate from 'lodash/truncate'
import { useTranslation } from 'i18n'
import { Confirm } from 'components/Dialog'
import { DELETE_POST, GET_POSTS } from 'request/apollo/queries/post'
import { useMessage } from 'components/Message/useMessage'
import { getPostsVariables } from 'components/pages/posts/PostView'

export default function Content({
  post,
  short = false,
  canEdit = false,
  onDeleteComplete = () => {},
  transitionAfterDelete = false,
  ...props
}) {
  const [editModal, setEditModal] = React.useState(false)
  const [confirmDelete, setConfirmDelete] = React.useState(false)
  const [mutate] = useMutation(DELETE_POST)
  const { flashMessage, sendMessage } = useMessage()

  const { t } = useTranslation('components')

  const onDelete = React.useCallback(() => {
    return mutate({
      variables: { postId: post.id },
      update: (cache, { data: { deletePost: deletedPost } }) => {
        let cacheData: any = { artist: { posts: { edges: [] } } }

        cacheData = cache.readQuery({
          query: GET_POSTS,
          variables: getPostsVariables(null), // アーティストが自分のポストを削除することが前提
        })

        if (cacheData?.artist) return

        const newEdges = cacheData.artist.posts.edges.filter(
          p => p.node.id !== deletedPost.id
        )
        cache.writeQuery({
          query: GET_POSTS,
          variables: getPostsVariables(null), // アーティストが自分のポストを削除することが前提
          data: {
            artist: {
              ...cacheData.artist,
              posts: {
                ...cacheData.artist.posts,
                edges: newEdges,
              },
            },
          },
        })
      },
    })
      .then(async () => {
        transitionAfterDelete
          ? flashMessage(t('pages.posts.Content.deleted'))
          : sendMessage(t('pages.posts.Content.deleted'))
        return onDeleteComplete()
      })
      .finally(() => {
        setConfirmDelete(false)
      })
  }, [])

  return (
    <div {...props}>
      <ActionSheet
        options={[t('pages.posts.Content.actionSheet.delete')]}
        open={editModal}
        onClose={e => {
          e.stopPropagation()
          setEditModal(false)
        }}
        cancel={true}
        onClick={index => {
          switch (index) {
            case 0:
              setEditModal(false)
              return setConfirmDelete(true)
            default:
              return
          }
        }}
      />
      <Confirm
        title={t('pages.posts.Content.confirmDelete')}
        open={confirmDelete}
        onSubmit={e => {
          e.stopPropagation()
          return onDelete()
        }}
        onClose={e => {
          e.stopPropagation()
          setConfirmDelete(false)
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Avatar user={post.artist} artist />
        {canEdit && (
          <IconButton
            onClick={e => {
              e.stopPropagation()
              setEditModal(true)
            }}
          >
            <Icon>more_vert</Icon>
          </IconButton>
        )}
      </div>
      <Description style={{ flex: '1 1 auto' }}>
        {short ? truncate(post.content, { length: 200 }) : post.content}
      </Description>
      <span style={{ fontSize: 12, color: '#4F5B62' }}>
        {format(post.createdAt)}
      </span>
    </div>
  )
}
